export enum ChatMessageFormat {
  Text = 1,
  Photo = 2,
  Sticker = 3,
  Video = 4,
  OfferLink = 5,
  TransferLink = 6,
  Gift = 7,
  MatchIcebreaker = 8,
  FollowUp = 9,
  WantsChat = 10,
  Icebreaker = 11,
}

export enum FakeChatMessageFormat {
  Match = -2,
}
